import { gql } from "graphql-request";

export const GET_CURRENT_USER = gql`
  query GetLoggedInUser {
    getLoggedInUser {
      data {
        firstName
        lastName
        profileImage
        cognitoUserId
        email
        userRole
        accessLevel
        assignedPartner
        createdBy
        isRestricted
        tenantId
        clientPermission {
          dashboard
          documents
          reports
        }
        allowedPages
        _id
      }
    }
  }
`;

export const LOGIN_MUTATION = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      data {
        accessToken
      }
    }
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation resetPassword($newPassword: String!, $token: String!) {
    resetPassword(newPassword: $newPassword, token: $token) {
      data {
        msg
        status
      }
    }
  }
`;

export const FORGET_MUTATION = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email) {
      data {
        msg
        status
      }
    }
  }
`;

export const BOOK_A_DEMO_MUTATION = gql`
  mutation BookADemo($name: String, $email: String, $companyName: String, $firmType: String) {
  bookADemo(name: $name, email: $email, companyName: $companyName, firmType: $firmType) {
    msg
    status
    }
  }
`;
export const UPDATE_USER_PASSWORD = gql`
  mutation Mutation(
    $newPassword: String!
    $email: String
    $previousPassword: String
    $newUser: Boolean
  ) {
    updateUserPassword(
      newPassword: $newPassword
      email: $email
      previousPassword: $previousPassword
      newUser: $newUser
    ) {
      data
    }
  }
`;
